import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import {FluxStock} from '../../model/fluxstock';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { plainToClass } from 'class-transformer';


@Injectable()
export class FluxStockService {

  iSconnecting: boolean = false;
  etatDetailProduit: FluxStock[];

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              ) { }

  getEtatFluxStock(idproduit: number) {

      this.iSconnecting = true;
      return new Promise<FluxStock[]>(resolve => {
          this.http.get(this.apiEndpoints.URL_GET_FLUXSTOCKPROD(idproduit),
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: FluxStock[]) =>  {
              const flux = plainToClass(FluxStock, data);
              this.etatDetailProduit = flux;
              resolve(flux);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
      });

  }

  saveFluxstock(fluxstock: FluxStock) {

      this.iSconnecting = true;
      const flux = {
        quantite: fluxstock.quantite,
        prixUnitaire: fluxstock.prix_unitaire,
        produit: fluxstock.produit.id,
        // tva: fluxstock.tva,
        facture: fluxstock.facture.id,
        libelle: '',
        createBy: null,
        // remise: fluxstock.remise,
        typeFlux: fluxstock.type_flux,
        dateFlux: this.sharedMethods.converStringToDatetime(fluxstock.date_flux),
        // natureStock: fluxstock.nature_stock,
        montant: fluxstock.prixTotal,
        commentaire : '',
        valider: false,
        cloturer: false,
      };


      if (fluxstock.id !== 0) {

        return new Promise<FluxStock>(resolve => {
          this.http.put(this.apiEndpoints.GET_URL_PUT_FLUXSTOCK(fluxstock.id), flux,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: FluxStock) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      } else {

        return new Promise<FluxStock>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_FLUXSTOCK, flux,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: FluxStock) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }



    }

    deleteFluxstock(fluxstock: FluxStock) {
      this.iSconnecting = true;
      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_FLUXSTOCK(fluxstock.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {
              resolve(data);
              this.iSconnecting = false;
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    }

}
